import { isLiquidGlassSupported } from '@callstack/liquid-glass';
import React from 'react';
import type { GestureResponderEvent } from 'react-native';

import { PressableSurface } from '@/components/ui';
import { hitSlop } from '@/constants';

type AuthBackButtonProps = {
  onPress: (event: GestureResponderEvent) => void;
  /** Liquid glass material variant (iOS 26+). Default `'regular'`. */
  glassEffect?: 'clear' | 'regular';
  accessibilityLabel?: string;
};

/**
 * Circular back button used across the auth flow. Renders an iOS Liquid Glass
 * surface where supported and falls back to a solid white circle otherwise.
 */
export function AuthBackButton({
  onPress,
  glassEffect = 'regular',
  accessibilityLabel = 'Go back',
}: AuthBackButtonProps) {
  return (
    <PressableSurface
      size={40}
      variant={isLiquidGlassSupported ? 'glass' : undefined}
      backgroundColor="rgba(255, 255, 255, 1)"
      glassEffect={glassEffect}
      onPress={onPress}
      hitSlop={hitSlop}
      accessibilityLabel={accessibilityLabel}>
      <PressableSurface.Icon name="IcBackBlue" size={24} color="#64748B" />
    </PressableSurface>
  );
}

export default AuthBackButton;
